import { default as Base } from '../services/services.Utils.js';
import { default as Utils } from '../utils/base.Utils.js';
export default class Academy extends Base {

  static get baseUrl() { 
    //return 'http://127.0.0.1:3005/AcademyFEService'
    return Utils.Configuration.academyBaseUrl;
  }

  constructor() {
    super();
  }

  static async getClasses(expand, waiter){
    const jsonData = {
      Expand: expand
    };
    const result = await super.doTheCall(
      JSON.stringify(jsonData), 
      {
        type: "POST",
        url: Academy.baseUrl + "/class/all"
      }, 
      waiter
    );

    //Traduci il titolo delle categorie
    result.data.forEach((el) => {
      if (el.CategoryTitle) {
        el.CategoryTitle = el.CategoryTitle[App.currentLanguage];
      } else {
        el.CategoryTitle = 'n.d.';
      }
    })

    return result;
  }

  static getPersonalLessons(waiter) {
    return super.doTheCall(
      null,
      {
        type: "POST",
        url: Academy.baseUrl + "/lesson/personal"
      },
      waiter
    );
  }

  static getChildren(waiter) {
    return super.doTheCall(
      null,
      {
        type: "POST",
        url: Academy.baseUrl + "/children/all"
      },
      waiter
    );
  }

  static book(edition, lessons, customers, waiter) {
    return super.doTheCall(
      JSON.stringify({
        IDEdition: edition,
        IDLessons: lessons,
        IDCustomers: customers
      }),
      {
        type: "POST",
        url: Academy.baseUrl + "/lessonbooking/create"
      },
      waiter
    );
  }

  static getBookings(lesson, waiter) {
    return super.doTheCall(
      JSON.stringify({
        IDLesson: lesson
      }),
      {
        type: "POST",
        url: Academy.baseUrl + `/lessonbooking/all`
      },
      waiter
    );
  }

  static deleteBookings(bookings, waiter) {
    return super.doTheCall(
      JSON.stringify({
        IDLessonBookings: bookings
      }),
      {
        type: "POST",
        url: Academy.baseUrl + `/lessonbooking/delete`
      },
      waiter
    );
  }

  static setPresences(settings, waiter) {
    return super.doTheCall(
      JSON.stringify(settings),
      {
        type: "POST",
        url: Academy.baseUrl + `/lessonbooking/presence`
      },
      waiter
    );
  }

  static getEmployeeRecap(waiter) {
    return super.doTheCall(
      null,
      {
        type: "GET",
        url: Academy.baseUrl + `/report/all`
      },
      waiter
    );
  }

  static getReport(edition, waiter) {
    return super.doTheCall(
      null,
      {
        type: "GET",
        dataType: "excel",
        url: Academy.baseUrl + `/report/edition/${edition}`
      },
      waiter
    );
  }

  static async getCategories(waiter) {
    const result = await super.doTheCall(
      null,
      {
        type: "GET",
        url: Academy.baseUrl + `/category/all`
      },
      waiter
    );

    //Traduci il titolo delle categorie
    result.data.forEach((el) => {
      if (el.Title) {
        el.Title = el.Title[App.currentLanguage];
      } else {
        el.Title = 'n.d.';
      }
    })

    return result;
  }

  static getCategoryDetail(categoryID, waiter) {
    return super.doTheCall(
      null,
      {
        type: "GET",
        url: Academy.baseUrl + `/category/show/${categoryID}`
      },
      waiter
    );
  }

  static deleteCustomerFromClass(IDCustomer, IDClass, waiter) {
    return super.doTheCall(
      JSON.stringify({
        IDCustomer,
        IDClass
      }),
      {
        type: "POST",
        url: Academy.baseUrl + `/lessonbooking/deleteCustomer`
      },
      waiter
    );
  }

  static getDomainCustomers(waiter) {
    return super.doTheCall(
      null,
      {
        type: "POST",
        url: Academy.baseUrl + `/search/users`
      },
      waiter
    );
  } 

  static getFullReport(jsonData, waiter) {
    return super.doTheCall(
      JSON.stringify({
        ClassID: jsonData.Class?.ID,
        EditionID: jsonData.Edition?.IDEdition,
        BookerID: jsonData.Booker?.ID,
        Department: jsonData.Department,
        StartDate: moment(jsonData.StartDate).format('yyyy/MM/DD'),
        EndDate: moment(jsonData.EndDate).format('yyyy/MM/DD'),
      }),
      {
        type: "POST",
        dataType: "excel",
        url: Academy.baseUrl + `/report/full`
      },
      waiter
    );
  } 
  
}
